export const CASE_STUDY_DATA_CREATE_REQUEST = 'CASE_STUDY_DATA_CREATE_REQUEST';
export const CASE_STUDY_DATA_CREATE_SUCCESS = 'CASE_STUDY_DATA_CREATE_SUCCESS';
export const CASE_STUDY_DATA_CREATE_FAIL = 'CASE_STUDY_DATA_CREATE_FAIL';
export const CASE_STUDY_DATA_CREATE_RESET = 'CASE_STUDY_DATA_CREATE_RESET';
